import { qualityApi } from 'api/quality';
import { receivingApi } from 'api/receiving';

import { mapPurchaseOrderMapGroupRows } from './mapPurchaseOrderMapGroupRows';

/**
 * @param {object} params
 * @param {number} params.poId
 * @param {boolean} params.isPackaging
 * @param {boolean} [params.isBamsReceivingOn]
 * @returns {Promise<{ rows: object[], editEnabled?: boolean | null, errorMessage?: string }>}
 */
async function fetchReceivableLineItems({ isBamsReceivingOn = false, isPackaging, poId }) {
    if (!isBamsReceivingOn) {
        const response = await qualityApi.getQualityPODetailsV2(poId, isPackaging);

        if (response.status === false) {
            return {
                rows: [],
                editEnabled: null,
                errorMessage: response.msg,
            };
        }

        return {
            rows: response.data.rows ?? [],
            editEnabled: response.data.jalapenoReceivingEditEnabled ?? false,
        };
    }

    const groupsResponse = isPackaging
        ? await receivingApi.getPackagingPurchaseOrderMapGroups(poId)
        : await receivingApi.getPurchaseOrderMapGroups(poId);

    if (groupsResponse.status === false) {
        return {
            rows: [],
            errorMessage: groupsResponse.msg ?? 'Failed to load map groups',
        };
    }

    const groupRows = groupsResponse.data?.rows ?? [];

    return {
        rows: mapPurchaseOrderMapGroupRows(groupRows, isPackaging),
    };
}

export { fetchReceivableLineItems };
